import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {Modal} from "@material-ui/core";
import styles from "./RerunSTT.module.css";
import {useDispatch} from "react-redux";
import PuiButton from "../../../components/elements/PuiButton";
import PuiTypography from "../../../components/elements/PuiTypography";
import {RerunSTT} from "../../../store/actions/ExVideoActions";
import useResponsive from "../../../common/useResponsive";

interface RerunSTTComponentProps {
    videoId: number;
    videoLanguage: string;
}

export default function RerunSTTComponent({videoId, videoLanguage}: RerunSTTComponentProps) {

    const dispatch = useDispatch();
    const history = useNavigate();
    const { isMobile } = useResponsive();

    // STT編集モーダル表示制御
    const [isOpenConfirmModal, ShowConfirmModal] = useState(false);

    const OpenConfirmModal = () => {
        ShowConfirmModal(true);
   };

    const CloseConfirmModal = () => {
        ShowConfirmModal(false);
   };

    const StartRerunSTT = () => {
        console.log("StartRerunSTT start");
        CloseConfirmModal();
        dispatch(RerunSTT(videoId, videoLanguage));
        history("/videos");
   };

    return (
        <div>
            <div className={styles.rerunSTTIcon}>
                <PuiButton variant="contained" fontSize={isMobile ? "0.8rem" : "0.875rem"} onClick={OpenConfirmModal}>
                    STT再実行
                </PuiButton>
            </div>

            {/* STT再実行確認モーダル */}
            <Modal
                open={isOpenConfirmModal}
                onClose={CloseConfirmModal}
                className={styles.container}
            >
                <div className={styles.confirmModal}>
                    <ul className={styles.ul}>
                        <li style={{textAlign:"center"}}>
                            <PuiTypography size={isMobile ? 14 : 16} bold={true}>STTを再実行しますか</PuiTypography>
                        </li>
                        <li style={{display:"flex"}}>
                            <div className={styles.verifyCancelButton}>
                                <PuiButton fontSize={isMobile ? "12px" : "0.875rem"} onClick={CloseConfirmModal}>
                                    キャンセル
                                </PuiButton>
                            </div>
                            <div className={styles.verifyConfirmButton}>
                                <PuiButton fontSize={isMobile ? "12px" : "0.875rem"} onClick={StartRerunSTT}>
                                    STT再実行
                                </PuiButton>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        </div>
    );
}
